import React, { useMemo } from "react";
import { AvatarOverlayLayer } from "./AvatarOverlayLayer";
import { HorizontalWorkspaceDeck } from "./HorizontalWorkspaceDeck";
import { OverallSummary } from "./OverallSummary";

export function LincWerksShell({
  config,
  role = config.currentRole || "viewer",
  brandMark,
  avatarRegistry,
  renderAvatar,
  onWorkspaceUpdate,
  onWorkspaceAction,
  onAddWorkspace,
  onOpenAssistant,
}) {
  const workspaces = useMemo(
    () => [...(config.workspaces || []), ...(config.addWorkspace ? [config.addWorkspace] : [])],
    [config.addWorkspace, config.workspaces],
  );

  return (
    <main className="lw-shell" data-edit-name="LincWerks home">
      <a className="lw-skip-link" href="#lw-active-workspace">Skip to active workspace</a>
      <header className="lw-topbar">
        <div className="lw-brand" aria-label="LincWerks">
          {brandMark ? (
            <span className="lw-brand__mark">{brandMark}</span>
          ) : (
            <span className="lw-brand__text">LincWerks</span>
          )}
        </div>
        <div className="lw-topbar__context">
          <strong>{config.title}</strong>
          <span>{config.subtitle}</span>
        </div>
        <button type="button" className="lw-assistant-button" onClick={onOpenAssistant}>
          Ask Linc or Arti
        </button>
      </header>

      <OverallSummary items={config.summary} />

      <div className="lw-shell__workspace" id="lw-active-workspace">
        <HorizontalWorkspaceDeck
          workspaces={workspaces}
          role={role}
          onUpdate={onWorkspaceUpdate}
          onAction={onWorkspaceAction}
          onAddWorkspace={onAddWorkspace}
        />
      </div>

      <AvatarOverlayLayer registry={avatarRegistry} renderAvatar={renderAvatar} />
    </main>
  );
}
